export class FavoritesOrderModel {
  constructor(public basketid: string = '', public description: string = '', public isdefault: boolean = false) {}
}

export class FavoritesOrderPayloadModel {
  constructor(public id: string = '', public token: string = '') {}
}
